/* eslint-disable consistent-return */
import styled, { css } from 'styled-components';

const HeaderContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: ${({ isDesktop, isStatisticsByPosting, device, currentTab }) => {
    if (isDesktop) return '24px';
    if (isStatisticsByPosting && device === 'mobile') return '16px';
    if (isStatisticsByPosting && device === 'tablet') return '32px';
    if (currentTab !== 'performance') return '0px';
    return '32px';
  }};
  ${({ portalWithBanner, device }) => {
    if (device !== 'desktop') {
      return css`
        margin-top: ${portalWithBanner ? 86 : 56}px;
      `;
    }
  }};
  ${({ isGeneralStatistics, device }) => {
    if (isGeneralStatistics && device !== 'desktop') {
      return css`
        margin-top: 0px;
      `;
    }
  }};
`;

export { HeaderContainer };
